<div>
  <div class="container block">
    <h2>Earning uPoints &amp; Badges</h2>
    <p>Collect badges and earn uPoints to boost the visibility of your profile to your peers. The more you participate (reading, rating, writing and sharing content), the more uPoints you'll earn. <a uiSref="leaderboard">View the Leaderboard</a></p>
    <div class="gamification clearfix">
      @for (badge of badges; track badge) {
        <div class="feed gamification">
          <div class="gamification-icon">
            <span class="profile-thumb large" [utBgImg]="badge.icon">
              @if (checkDone(badge.id)) {
                <span title="Done" class="avatar-badges-wrapper">
                  <span class="avatar-badge avatar-badge-check"><i class="icon-check"></i></span>
                </span>
              }
            </span>
          </div>
          <div class='gamification-content'>
            <h5>{{badge.name}}</h5>
            <p>{{badge.description}}</p>
          </div>
          <div class="gamification-points">{{badge.points}} pts</div>
        </div>
      }
    </div>
  </div>
</div>
